export const uk = {
    add: 'Добавить'
};
